import React, { useState, FormEvent, useEffect } from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import './style/login.css';
import { Link } from 'react-router-dom';
import { login } from '../../actions/UserManagement';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [rememberMe, setRememberMe] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Login | Vinimark | The Wine Company';
    }, []);

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setErrorMessage('');

        try {
            const response = await login(email, password, rememberMe);
            if (response.status === 200) {
                navigate('/dashboard', { state: { user: response.data.user } });
            } else {
                setErrorMessage('Invalid email or password. Please try again.');
            }
        } catch (error) {
            console.error('Login failed:', error);
            setErrorMessage('Invalid email or password. Please try again.');
        }
    };

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                width: '100%',
            }}
        >
            <Header />

            <div className="forgot-password-container">
                <div className="forgot-password-inner">
                    <div className="site-grid" style={{ width: '100%' }}>
                        <div className="item item-double-content">
                            <div className="item-inner"></div>

                            <div className="item-inner item-inner-content">
                                <div className="content">
                                    <div className="content-title">
                                        <h2 className="content-title-small">Login</h2>
                                    </div>
                                    <div className="content-text">
                                        <p className="content-text">
                                            By entering your Email and Password, you will have access to the Vinimark CMS.
                                        </p>
                                    </div>

                                    <form className="content-form" onSubmit={handleSubmit}>
                                        <div className="content-form-field">
                                            <input
                                                type="text"
                                                className="input-email"
                                                placeholder="Email Address"
                                                value={email}
                                                onChange={(e) => {
                                                    setEmail(e.target.value);
                                                    setErrorMessage('');
                                                }}
                                                required
                                            />
                                        </div>
                                        <div className="content-form-field">
                                            <input
                                                type="password"
                                                className="input-email"
                                                placeholder="Password"
                                                value={password}
                                                onChange={(e) => {
                                                    setPassword(e.target.value);
                                                    setErrorMessage('');
                                                }}
                                                required
                                            />
                                        </div>

                                        <div
                                            className="content-form-field"
                                            style={{ display: 'flex', alignItems: 'center' }}
                                        >
                                            <input
                                                type="checkbox"
                                                id="rememberMe"
                                                checked={rememberMe}
                                                onChange={(e) => setRememberMe(e.target.checked)}
                                            />
                                            <label htmlFor="rememberMe" className="rememberLabel" style={{ marginLeft: '10px' }}>
                                                Remember Me
                                            </label>
                                        </div>

                                        {errorMessage && (
                                            <div className="error-message" style={{ color: 'red', marginTop: '10px', fontFamily: "'Vinimark-Diatype', sans-serif", fontWeight: 400 }}>
                                                {errorMessage}
                                            </div>
                                        )}

                                        <div className="content-form-button">
                                            <button className="button button-wide" type="submit">
                                                Login
                                            </button>
                                        </div>

                                        <div className="content-next">
                                            <Link to="/forgot-password">FORGOT PASSWORD</Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Login;
